import React from "react";
import styles from "./ConfirmDeleteModal.module.scss";

type ConfirmDeleteModalProps = {
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
};

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  onClose,
  onConfirm,
  title = "Подтверждение удаления",
  message = "Вы уверены, что хотите удалить эту тренировку?",
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose}></div>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2>{title}</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.content}>
          <p className={styles.message}>{message}</p>
        </div>

        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onClose}>
            Отмена
          </button>
          <button className={styles.confirmBtn} onClick={handleConfirm}>
            Удалить
          </button>
        </div>
      </div>
    </>
  );
};





















